import { render, staticRenderFns } from "./GasAppliances.vue?vue&type=template&id=c650ff68&scoped=true&"
import script from "./GasAppliances.vue?vue&type=script&lang=js&"
export * from "./GasAppliances.vue?vue&type=script&lang=js&"
import style0 from "./GasAppliances.vue?vue&type=style&index=0&id=c650ff68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c650ff68",
  null
  
)

export default component.exports